module.exports = __webpack_public_path__ + "static/everyday-verbs-545e7377f853536ddc7ce823ddfe9eaf.jpg";